import {
  createDefaultColorOptions,
  createMarkupEditorShapeStyleControls,
  createMarkupEditorToolStyle,
  createMarkupEditorToolStyles,
} from '@pqina/pintura';

export const ImageViewerProperties = {
  markupEditorToolbar: [
    [
      'rectangle',
      'Square',
      {
        icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1.61069" y="1.61069" width="20.7786" height="20.7786" stroke="#E1E1E1" stroke-width="3.22137"/>
        </svg>
        `,
      },
    ],
    [
      'arrow',
      'Arrow',
      {
        icon: `<svg width="31" height="24" viewBox="0 0 31 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.58316 4.44377C0.723908 4.67401 0.213992 5.55721 0.444227 6.41645L4.19612 20.4187C4.42635 21.2779 5.30955 21.7879 6.1688 21.5576C7.02804 21.3274 7.53796 20.4442 7.30772 19.5849L3.97271 7.1385L16.4191 3.80349C17.2784 3.57326 17.7883 2.69006 17.5581 1.83081C17.3278 0.971564 16.4446 0.461649 15.5854 0.691883L1.58316 4.44377ZM30.7033 20.7115L2.80537 4.60468L1.19469 7.39447L29.0926 23.5013L30.7033 20.7115Z" fill="#E1E1E1"/>
      </svg>
      `,
      },
    ],
    [
      'ellipse',
      'Circle',
      {
        icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10.3893" stroke="#E1E1E1" stroke-width="3.22137"/>
    </svg>
    `,
      },
    ],
    [
      'sharpie',
      'Brush',
      {
        icon: `<svg width="30" height="25" viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.8099 16.2951L27.3487 4.75417L25.5576 2.96275L14.0188 14.5037L15.8099 16.2951ZM6.81995 19.2923C4.52367 19.1775 2.81294 18.6952 1.68776 17.8454C0.562588 16.9956 0 15.7669 0 14.1592C0 12.6663 0.614254 11.4548 1.84276 10.5246C3.07127 9.59447 4.77626 9.03752 6.95772 8.85379C7.85327 8.78488 8.52493 8.64134 8.97271 8.42315C9.42048 8.20497 9.64437 7.90065 9.64437 7.51022C9.64437 6.91307 9.30567 6.46522 8.62826 6.16664C7.95086 5.86807 6.83143 5.64989 5.26996 5.51208L5.51107 2.75604C7.87623 2.93978 9.61566 3.41634 10.7294 4.18574C11.8431 4.95513 12.3999 6.06329 12.3999 7.51022C12.3999 8.72747 11.9579 9.6806 11.0738 10.3696C10.1897 11.0586 8.8866 11.472 7.16439 11.6098C5.69477 11.7247 4.59256 11.9945 3.85775 12.4194C3.12294 12.8443 2.75553 13.4242 2.75553 14.1592C2.75553 14.963 3.07701 15.5429 3.71997 15.8989C4.36293 16.2549 5.44218 16.4674 6.95772 16.5363L6.81995 19.2923ZM16.4643 19.5334L10.781 13.8491L23.9387 0.689011C24.398 0.22967 24.9433 0 25.5748 0C26.2063 0 26.7516 0.22967 27.2109 0.689011L29.622 3.10055C30.0812 3.55989 30.3109 4.10535 30.3109 4.73695C30.3109 5.36854 30.0812 5.91401 29.622 6.37335L16.4643 19.5334ZM10.9877 20.6703C10.5973 20.7622 10.2529 20.6588 9.95436 20.3603C9.65585 20.0617 9.55252 19.7172 9.64437 19.3267L10.781 13.8491L16.4643 19.5334L10.9877 20.6703Z" fill="#E1E1E1"></path>
        </svg>`,
      },
    ],
  ],
  markupEditorShapeStyleControls: createMarkupEditorShapeStyleControls({
    colorOptions: [
      [createDefaultColorOptions().white, 'white'],
      [createDefaultColorOptions().black, 'black'],
      [createDefaultColorOptions().red, 'red'],
      [createDefaultColorOptions().yellow, 'yellow'],
      [createDefaultColorOptions().green, 'green'],
    ],
    lineEndStyleOptions: false,
    fontFamilyOptions: false,
    fontStyleOptions: false,
    textAlignOptions: false,
    strokeWidthOptions: false,
    fontSizeOptions: false,
    lineHeightOptions: false,
  }),
  markupEditorToolStyles: createMarkupEditorToolStyles({
    rectangle: createMarkupEditorToolStyle('rectangle', {
      backgroundColor: createDefaultColorOptions().transparent,
      strokeColor: createDefaultColorOptions().white,
      strokeWidth: '1.5%',
      disableStyle: ['cornerRadius', 'backgroundColor'],
      disableErase: false,
    }),
    ellipse: createMarkupEditorToolStyle('ellipse', {
      backgroundColor: createDefaultColorOptions().transparent,
      strokeColor: createDefaultColorOptions().white,
      strokeWidth: '1.5%',
      disableStyle: ['cornerRadius', 'backgroundColor'],
    }),
    arrow: createMarkupEditorToolStyle('line', {
      backgroundColor: createDefaultColorOptions().transparent,
      strokeColor: createDefaultColorOptions().white,
      strokeWidth: '1%',
      disableStyle: ['cornerRadius', 'backgroundColor'],
      lineEnd: 'arrow-solid',
    }),
    sharpie: createMarkupEditorToolStyle('path', {
      backgroundColor: createDefaultColorOptions().transparent,
      strokeColor: createDefaultColorOptions().white,
      strokeWidth: '1.5%',
      disableStyle: ['cornerRadius', 'backgroundColor'],
    }),
  }),
};
